


























import { Component, Vue, Prop } from 'vue-property-decorator';
import EditOnClickField from '@/components/util/EditOnClickField.vue';
import { Campus, PerformoSettings, WorkordersApi } from 'performo-api';
import { mapGetters } from 'vuex';
import CampusPicker from '@/components/system/CampusPicker.vue';

@Component({
  components: { EditOnClickField, CampusPicker },
  computed: mapGetters({
    settings: 'settings',
    ordersApi: 'ordersApi'
  })
})
export default class CampusEditor extends Vue {
  @Prop({ required: true, type: String, default: '' })
  private workorderId!: string;

  @Prop({ required: false, default: false })
  private canEdit!: boolean;

  @Prop({ required: false, type: String, default: 'Campus' })
  private label!: string;

  @Prop({ required: true, default: '' })
  private value!: string | number;

  @Prop({ required: true, type: String })
  private propertyId!: string;

  private ordersApi!: WorkordersApi;
  private CampusMode = 'read';
  private updatedValue: string | number | undefined = undefined;
  private loading!: boolean;
  private settings!: PerformoSettings;
  private pickedCampus?: Campus;

  data() {
    return {
      loading: false,
      updatedValue: this.value
    };
  }

  private get campusLabel() {
    return this.settings.campusLabelSingular;
  }

  // valueUpdate getter and setters are not referenced anywhere. Remove?
  // https://dev.azure.com/wizardsoftware/Performo.Api/_workitems/edit/1980/
  get valueUpdate() {
    return this.updatedValue || this.value;
  }
  set valueUpdate(val) {
    this.updatedValue = val;
  }

  private handleCampusPicked(campus: Campus) {
    this.pickedCampus = campus;
  }

  private async handleCampusChange(campus: string) {
    // update if we have an order
    if (!this.workorderId) {
      return;
    }

    // don't do anything if the new value is the same as the input
    if (this.value === campus) {
      this.exitEdit();
      return;
    }

    // set loading
    this.loading = true;

    // perform api call
    try {
      const updated = await this.ordersApi.changeCampus({
        workorderId: this.workorderId,
        changeOrderCampusCommand: {
          newCampus: campus
        }
      });
      this.$emit('input', updated);
      this.$emit('campus-changed', this.pickedCampus);
    } catch (error) {
      this.$emit('error', error);
    }

    this.exitEdit();
  }

  private exitEdit() {
    // revert to display mode
    this.CampusMode = 'read';
    this.loading = false;
  }
}
